enum LocaleEnum {
    PL = "pl",
    EN = "en",
}

export default LocaleEnum;
